
export default {
  data() {
    return {
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    // 根据视频对象种类和状态返回树节点图标类名
    streamNodeIconClassFromStreamObjectKindAndState(streamObjectKind, alarmState, eventType, workState) {
      let state = 0
      if (alarmState === 0) {
        state = workState
      } else if (alarmState === 1) {
        if (eventType === 0x20) { // 离线
          state = 2
        } else {
          state = 3
        }
      } else {
        state = 2
      }

      switch (streamObjectKind) {
        case 0:
        case 1: // 球机
          switch (state) {
            case 0:
              return 'tree-node-icon-speed-dome'
            case 1:
              return 'tree-node-icon-speed-dome-active'
            case 2:
              return 'tree-node-icon-speed-dome-disabled'
            case 3:
              return 'tree-node-icon-speed-dome-alarm'
          }
          break
        case 12: // 半球
          switch (state) {
            case 0:
              return 'tree-node-icon-dome'
            case 1:
              return 'tree-node-icon-dome-active'
            case 2:
              return 'tree-node-icon-dome-disabled'
            case 3:
              return 'tree-node-icon-dome-alarm'
          }
          break
        case 2:
        case 11:
        case 13:
        case 14: // 枪机
          switch (state) {
            case 0:
              return 'tree-node-icon-box-camera'
            case 1:
              return 'tree-node-icon-box-camera-active'
            case 2:
              return 'tree-node-icon-box-camera-disabled'
            case 3:
              return 'tree-node-icon-box-camera-alarm'
          }
          break
        default: return 'tree-node-icon-box-camera'
      }
      return 'tree-node-icon-box-camera'
    },
    // 根据资源告警状态返回颜色类名
    colorClassFromResourceAlarmState: function (resourceKind, alarmState, eventType, deployed, encoderAlarmState, encoderEventType) {
      if (!deployed) {
        return 'normal-color'
      }

      if (alarmState === 1) {
        if (resourceKind === 0) { // 监控设备
          if (eventType === 0x01) {
            return 'offline-color'
          } else {
            return 'alarm-color'
          }
        } else if (resourceKind === 22) { // 信号量输入
          if (eventType === 0x04) {
            return 'offline-color'
          } else {
            return 'alarm-color'
          }
        } else if (resourceKind === 23) { // 模拟量输入
          if (eventType === 0x20) {
            return 'offline-color'
          } else {
            return 'alarm-color'
          }
        } else {
          return 'alarm-color'
        }
      } else if (alarmState === 0) {
        if (resourceKind === 0) { // 监控设备
          return 'normal-color'
        } else {
          if (encoderAlarmState === 1 && encoderEventType === 0x01) {
            return 'offline-color'
          } else {
            return 'normal-color'
          }
        }
      } else {
        return 'unknown-color'
      }
    },
    // 根据资源告警状态返回Tag类型
    tagTypeFromResourceAlarmState: function (resourceKind, alarmState, eventType, deployed, encoderAlarmState, encoderEventType) {
      if (!deployed) {
        return 'success'
      }

      if (alarmState === 1) {
        if (resourceKind === 0) { // 监控设备
          if (eventType === 0x01) {
            return 'info'
          } else {
            return 'danger'
          }
        } else if (resourceKind === 22) { // 信号量输入
          if (eventType === 0x04) {
            return 'info'
          } else {
            return 'danger'
          }
        } else if (resourceKind === 23) { // 模拟量输入
          if (eventType === 0x20) {
            return 'info'
          } else {
            return 'danger'
          }
        } else {
          return 'danger'
        }
      } else if (alarmState === 0) {
        if (resourceKind === 0) { // 监控设备
          return 'success'
        } else {
          if (encoderAlarmState === 1 && encoderEventType === 0x01) {
            return 'info'
          } else {
            return 'success'
          }
        }
      } else {
        return 'info'
      }
    },
    // 根据资源在线状态返回颜色类名
    colorClassFromResourceOnlineState: function (resourceKind, alarmState, eventType, encoderAlarmState, encoderEventType) {
      if (alarmState === 1) {
        if (resourceKind === 0) { // 监控设备
          if (eventType === 0x01) {
            return 'offline-color'
          } else {
            return 'online-color'
          }
        } else if (resourceKind === 21) { // 视频节点
          if (eventType === 0x20) {
            return 'offline-color'
          } else {
            return this.colorClassFromResourceOnlineState(0, encoderAlarmState, encoderEventType, 0, 0)
          }
        } else if (resourceKind === 22) { // 信号量输入
          if (eventType === 0x04) {
            return 'offline-color'
          } else {
            return this.colorClassFromResourceOnlineState(0, encoderAlarmState, encoderEventType, 0, 0)
          }
        } else if (resourceKind === 23) { // 模拟量输入
          if (eventType === 0x20) {
            return 'offline-color'
          } else {
            return this.colorClassFromResourceOnlineState(0, encoderAlarmState, encoderEventType, 0, 0)
          }
        } else {
          return this.colorClassFromResourceOnlineState(0, encoderAlarmState, encoderEventType, 0, 0)
        }
      } else if (alarmState === 0) {
        if (resourceKind === 0) { // 监控设备
          return 'online-color'
        } else {
          return this.colorClassFromResourceOnlineState(0, encoderAlarmState, encoderEventType, 0, 0)
        }
      } else {
        return this.colorClassFromResourceOnlineState(0, encoderAlarmState, encoderEventType, 0, 0)
      }
    },
    // 根据资源控制数值返回颜色类名
    colorClassFromResourceControlValue: function (resourceKind, controlValue, valueType) {
      if (resourceKind === 24) { // 信号量输出
        if (valueType === 0) { // 0-值1为打开设备,1-值0为打开设备
          return controlValue === 1 ? 'on-color' : 'off-color'
        } else if (valueType === 1) {
          return controlValue === 0 ? 'on-color' : 'off-color'
        } else {
          return 'off-color'
        }
      } else if (resourceKind === 25) { // 模拟量输出
        return 'off-color'
      } else {
        return 'off-color'
      }
    },
    // 根据资源种类和子类型返回资源图片文件名称
    deviceImageFileNameByResourceKindAndSubType(resourceKind, resourceSubType) {
      if (resourceKind === 22) {
        return ''
      } else if (resourceKind === 23) {
        return ''
      } else if (resourceKind === 24) {
        switch (resourceSubType) {
          case 0:
            return require('@/assets/img/device/light.png')
          case 1:
            return require('@/assets/img/device/warning.png')
          case 2:
            return require('@/assets/img/device/ring.png')
          case 3:
            return require('@/assets/img/device/ac.png')
          case 13:
            return require('@/assets/img/device/dehumidifier.png')
          case 15:
            return require('@/assets/img/device/draught-fan.png')
          case 20:
            return require('@/assets/img/device/door.png')
          default:
            return require('@/assets/img/device/door.png')
        }
      } else if (resourceKind === 25) {
        switch (resourceSubType) {
          case 0:
            return require('@/assets/img/device/temperature.png')
          case 1:
            return require('@/assets/img/device/humidity.png')
          default:
            return require('@/assets/img/device/temperature.png')
        }
      } else {
        return ''
      }
    },
    // 根据资源种类和子类型返回资源图片文件名称
    deviceImage128FileNameByResourceKindAndSubType(resourceKind, resourceSubType) {
      if (resourceKind === 22) {
        switch (resourceSubType) {
          case 0:
            return '/static/img/device/icon_device_water_detect_128.png'
          case 1:
            return '/static/img/device/icon_device_infrared_128.png'
          case 2:
            return '/static/img/device/icon_device_infrared_pair_128.png'
          case 4:
            return '/static/img/device/icon_device_smoke_sensor_128.png'
          case 5:
            return '/static/img/device/icon_device_door_128.png'
          case 11:
            return '/static/img/device/icon_device_draught_fan_128.png'
          case 12:
            return '/static/img/device/icon_device_ac_128.png'
          default:
            return '/static/img/device/icon_device_smoke_sensor_128.png'
        }
      } else if (resourceKind === 23) {
        switch (resourceSubType) {
          case 0:
            return '/static/img/device/icon_device_temperature_128.png'
          case 1:
            return '/static/img/device/icon_device_humidity_128.png'
          case 2:
            return '/static/img/device/icon_device_thickness_128.png'
          default:
            return '/static/img/device/icon_device_temperature_128.png'
        }
      } else if (resourceKind === 24) {
        switch (resourceSubType) {
          case 20:
            return '/static/img/device/icon_device_door_128.png'
          case 15:
            return '/static/img/device/icon_device_draught_fan_128.png'
          case 3:
            return '/static/img/device/icon_device_ac_128.png'
          default:
            return '/static/img/device/icon_device_door_128.png'
        }
      } else if (resourceKind === 25) {
        switch (resourceSubType) {
          case 0:
            return '/static/img/device/icon_device_temperature_128.png'
          case 1:
            return '/static/img/device/icon_device_humidity_128.png'
          default:
            return '/static/img/device/icon_device_temperature_128.png'
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/type-image-mixin.js